import React, { useEffect, useState } from "react";
import Modal from "common/components/Modal";
import Select from "common/components/Select";
import axios from "common/configs/axiosConfigs";
import { toast } from "react-toastify";
import { FURNISHED_OPTIONS, OPTIONS } from "common/constants/enums";

const Filter = ({ onClose, isOpen, handleFilter, filter, getProperties }) => {
  const [propertyTypes, setPropertyTypes] = useState([]);
  const PROPERTY_TYPES = propertyTypes?.map((p) => ({ value: p?.id, label: p?.name }));
  const handleFilterApply = (e) => {
    e.preventDefault();
    getProperties();
    onClose();
  };
  const getPropertyTypes = async () => {
    try {
      const { data } = await axios.post("", { action: "getPropertyType" });
      if (data.success) {
        setPropertyTypes(data?.data);
      } else {
        toast.error(data.error);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };
  useEffect(() => {
    getPropertyTypes();
  }, []);
  return (
    <Modal
      {...{
        onClose,
        isOpen,
        title: "Property Filters",
      }}
    >
      <form onSubmit={handleFilterApply}>
        <div className="filter-box row gy-4 ">
          <div className="col-lg-6">
            <Select
              placeholder="Property Type"
              name="propertyType"
              value={filter.propertyType}
              options={PROPERTY_TYPES}
              onChange={handleFilter}
            />
          </div>
          <div className="col-lg-6">
            <input
              type="text"
              className="form-control"
              name="location"
              placeholder="Location"
              value={filter.location}
              onChange={handleFilter}
            />
          </div>
          <div className="col-lg-6">
            <Select
              placeholder="BHK"
              name="bedroom"
              onChange={handleFilter}
              value={filter.bedroom}
              options={OPTIONS}
            />
          </div>
          <div className="col-lg-6">
            <Select
              placeholder="Furnishing Status"
              value={filter.furnished}
              name="furnished"
              onChange={handleFilter}
              options={FURNISHED_OPTIONS}
            />
          </div>
          <div className="col-6">
            <input
              type="number"
              name="minBudget"
              value={filter.minBudget}
              onChange={handleFilter}
              placeholder="Min Budget"
              className="form-control"
              required={filter.maxBudget}
            />
          </div>
          <div className="col-6">
            <input
              type="number"
              name="maxBudget"
              value={filter.maxBudget}
              onChange={handleFilter}
              placeholder="Max Budget"
              className="form-control"
              required={filter.minBudget}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end  border-top mb-n3 mt-3 pt-3">
          <button type="button" className="btn btn-light">
            Cancel
          </button>
          <button type="submit" className="btn btn-primary ms-2">
            Apply
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default Filter;
